module.exports = __webpack_public_path__ + "assets/slike/tenkovi/jna-tenk-cev.82ed0aac7d6de7654a69bb3d4fb4609f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/slike/tenkovi/jna-tenk-cev.png
// module id = 36
// module chunks = 0